import { Button, CheckmarkCircleFilledIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { useMobile } from '@/hooks'
import { NewScheduledCommunicationTemplateDetails } from '@/types/ScheduledCommunicationTemplate'

type Props = {
  scheduledCommunicationTemplate: NewScheduledCommunicationTemplateDetails
  toggle: () => void
}

export const CreateScheduledCommunicationTypeConfirmation = ({ scheduledCommunicationTemplate, toggle }: Props) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const createdAt = formatInTimeZone(scheduledCommunicationTemplate.createdAt, timezone, 'MMM dd, yyyy, h:mmaaa')

  const { isTablet } = useMobile()

  return (
    <ScheduledCommunicationTypeConfirmation className="flex w-full flex-col flex-wrap px-6">
      <h2 className=" mb-6 flex items-center rounded-2xl px-6 py-4 text-white bg-accent-dark">
        <CheckmarkCircleFilledIcon className="mr-4 h-4 text-black" />{' '}
        <span className="leading-none">Scheduled Communication Type ID: {scheduledCommunicationTemplate.id}</span>
      </h2>
      <div className="scheduled-communication-type-line-item">
        <p>Market Segment</p>
        <p className="font-bold">{scheduledCommunicationTemplate.marketSegment}</p>
      </div>
      <div className="scheduled-communication-type-line-item">
        <p>Scheduled Communication Type</p>
        <p className="font-bold">{scheduledCommunicationTemplate.scheduledCommunicationType}</p>
      </div>

      <div className="scheduled-communication-type-line-item">
        <p>Created at</p>
        <p className="font-bold">{createdAt}</p>
      </div>

      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Close
        </Button>
      </div>
    </ScheduledCommunicationTypeConfirmation>
  )
}

export const ScheduledCommunicationTypeConfirmation = styled.div`
  .scheduled-communication-type-line-item {
    display: flex;
    height: 3.5rem;
    width: 100%;
    justify-content: space-between;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    overflow: hidden;
    border-bottom-width: 1px;
    border-color: #e7e6e4;
    margin-bottom: 0.25rem;
    p {
      &:first-of-type {
        line-height: 1.2;
        color: #787573;
        display: flex;
        align-items: center;
      }

      &:last-of-type {
        max-width: 50%;
        text-align: right;
        display: flex;
        align-items: center;
      }
    }
  }

  .font-bold {
    font-weight: 700;
  }
`
